import React, {useEffect, useState} from 'react';
// import {InfoWindow, GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";
import {Link} from "react-router-dom";
import Rating from '@material-ui/lab/Rating';
import Geocode from 'react-geocode';
// import Autocomplete from 'react-google-autocomplete';
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import '../App.scss';

Geocode.setApiKey('AIzaSyC5vsZ5_i3euLtKBmrPTcDM7ztQeAFa8HY');
Geocode.enableDebug();

export default function Food() {

    const [map, setMap] = useState({
        address: "",
        city: "",
        area: "",
        state: "",
        zoom: 15,
        height: 400,
        mapPosition: {
            lat: 0,
            lng: 0
        },
        markerPosition: {
            lat: 0,
            lng: 0
        }
    });

    const [resto, setResto] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getLocation();
    }, []);

    useEffect(() => {
        fetchResto(map.markerPosition.lng, map.markerPosition.lat)
    }, [map])

    const getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getCoordinates, handleLocationError);
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    }

    const fetchResto = (lng, lat) => {
        setLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("user-key", "dd699931f972d3e9cb83bc83c386289c");
        myHeaders.append("Cookie", "fbcity=74; zl=en; fbtrack=18d4cdbd7b73ce2945cd735a3ff1fd83; AWSALBTG=bK7IjJtYszeTHHpoyYvoFa+JtfobjxUw0Zk0nNZrY3UMrP3sLVvzXmxMuqixyBKRa5AflcL7BGKEwgW9EV2VsPPsKOqVZ4lSctAM9EiO7Z1MmpeGdOEvgmILQ/IWa5v56Zj2aUgEeugGBklBiJa5YEGoQbRYUZ9a2gEAPpmi0B7FhtjAKbY=; AWSALBTGCORS=bK7IjJtYszeTHHpoyYvoFa+JtfobjxUw0Zk0nNZrY3UMrP3sLVvzXmxMuqixyBKRa5AflcL7BGKEwgW9EV2VsPPsKOqVZ4lSctAM9EiO7Z1MmpeGdOEvgmILQ/IWa5v56Zj2aUgEeugGBklBiJa5YEGoQbRYUZ9a2gEAPpmi0B7FhtjAKbY=; csrf=86ddd08f37acd3fa5ada6f50f90b2439");

        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        console.log(lng, lat, 'helo world');

        fetch(`https://developers.zomato.com/api/v2.1/geocode?lat=${lat || map.markerPosition.lat}&lon=${lng || map.markerPosition.lng}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if(result.nearby_restaurants) {
                    setResto(result.nearby_restaurants)
                } else {
                    setResto([])
                }
                setLoading(false);
                console.log(result)
            })
            .catch(error => console.log('error', error));
    }

    const getCoordinates = (pos) => {
        console.log(pos, 'helo pos');
        setMap({
            ...map,
            markerPosition: {
                lng: pos.coords.longitude,
                lat: pos.coords.latitude
            },
            mapPosition: {
                lng: pos.coords.longitude,
                lat: pos.coords.latitude
            }
        });
    }

    // const onInfoWindowClose = (event) => { };

    // const getCity = (addressArray) => {
    //     let city = '';
    //     for (let i = 0; i < addressArray.length; i++) {
    //         if (addressArray[i].types[0] && 'administrative_area_level_2' === addressArray[i].types[0]) {
    //             city = addressArray[i].long_name;
    //             return city;
    //         }
    //     }
    // };
    //
    // const getArea = (addressArray) => {
    //     let area = '';
    //     for (let i = 0; i < addressArray.length; i++) {
    //         if (addressArray[i].types[0]) {
    //             for (let j = 0; j < addressArray[i].types.length; j++) {
    //                 if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
    //                     area = addressArray[i].long_name;
    //                     return area;
    //                 }
    //             }
    //         }
    //     }
    // };
    //
    // const getState = (addressArray) => {
    //     let state = '';
    //     for (let i = 0; i < addressArray.length; i++) {
    //         for (let i = 0; i < addressArray.length; i++) {
    //             if (addressArray[i].types[0] && 'administrative_area_level_1' === addressArray[i].types[0]) {
    //                 state = addressArray[i].long_name;
    //                 return state;
    //             }
    //         }
    //     }
    // };

    // const onDragEnd = (e) => {
    //     let newLat = e.latLng.lat();
    //     let newLng = e.latLng.lng();
    //
    //     Geocode.fromLatLng(newLat, newLng).then(res => {
    //         const address = res.results[0].formatted_address,
    //         addressArray = res.results[0].address_components,
    //
    //         city = getCity(addressArray),
    //         area = getArea(addressArray),
    //         state = getState(addressArray);
    //
    //         console.log('city', city, area, state);
    //
    //         setMap({
    //             ...map,
    //             markerPosition: {
    //                 lng: e.latLng.lng(),
    //                 lat: e.latLng.lat()
    //             },
    //             mapPosition: {
    //                 lng: e.latLng.lng(),
    //                 lat: e.latLng.lat()
    //             },
    //             address: (address) ? address : '',
    //             area: (area) ? area : '',
    //             city: (city) ? city : '',
    //             state: (state) ? state : '',
    //         })
    //     }, error => {
    //         console.log(error, 'error drag end')
    //     })
    // }
    //
    // const onPlaceSelected = (place) => {
    //     console.log('plc', place);
    //     const address = place.formatted_address,
    //     addressArray = place.address_components,
    //     city = getCity(addressArray),
    //     area = getArea(addressArray),
    //     state = getState(addressArray),
    //     latValue = place.geometry.location.lat(),
    //     lngValue = place.geometry.location.lng();
    //
    //     console.log('latvalue', latValue)
    //     console.log('lngValue', lngValue)
    //
    //     // Set these values in the state.
    //     setMap({
    //         ...map,
    //         address: (address) ? address : '',
    //         area: (area) ? area : '',
    //         city: (city) ? city : '',
    //         state: (state) ? state : '',
    //         markerPosition: {
    //             lat: latValue,
    //             lng: lngValue
    //         },
    //         mapPosition: {
    //             lat: latValue,
    //             lng: lngValue
    //         },
    //     })
    // };

    // const MapWithAMarker = withScriptjs(withGoogleMap(props =>
    //     <GoogleMap
    //         defaultZoom={15}
    //         defaultCenter={{ lat: map.mapPosition.lat, lng: map.mapPosition.lng }}
    //     >
    //         <Marker
    //             google={props.google}
    //             draggable={true}
    //             onDragEnd={onDragEnd}
    //             position={{ lat: map.markerPosition.lat, lng: map.markerPosition.lng }}
    //         >
    //             {map.address && (
    //                 <InfoWindow
    //                     onClose={onInfoWindowClose}
    //                     position={{ lat: (map.markerPosition.lat + 0.0018), lng: map.markerPosition.lng }}
    //                 >
    //                     <div>
    //                         <span style={{ padding: 0, margin: 0 }}>{map.address}</span>
    //                     </div>
    //                 </InfoWindow>
    //             )}
    //         </Marker>
    //         <Autocomplete
    //             style={{
    //                 width: '100%',
    //                 height: '40px',
    //                 paddingLeft: '16px',
    //                 marginTop: '2px',
    //                 marginBottom: '2rem',
    //                 border: 'none'
    //             }}
    //             onPlaceSelected={onPlaceSelected}
    //             types={['address']}
    //         />
    //     </GoogleMap>
    // ));

    const handleLocationError = (error) => {
        switch(error.code) {
            case error.PERMISSION_DENIED:
                alert("User denied the request for Geolocation.");
                break;
            case error.POSITION_UNAVAILABLE:
                alert("Location information is unavailable.");
                break;
            case error.TIMEOUT:
                alert("The request to get user location timed out.");
                break;
            case error.UNKNOWN_ERROR:
                alert("An unknown error occurred.");
                break;
            default:
                alert("An unknown error occurred.");
        }
    }

    function currencyFormat(curr, num) {
        return `${curr} ` + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    function myNavFunc(lat, lng) {
        window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${lat},${lng}`);
    }

    const rand = Math.floor(Math.random() * 9);

    function getDistanceFromLatLng(lat1, lng1, lat2, lng2, miles) { // miles optional
        if (typeof miles === "undefined"){miles=false;}
        function deg2rad(deg){return deg * (Math.PI/180);}
        function square(x){return Math.pow(x, 2);}
        const r=6371; // radius of the earth in km
        lat1=deg2rad(lat1);
        lat2=deg2rad(lat2);
        const lat_dif=lat2-lat1;
        const lng_dif=deg2rad(lng2-lng1);
        const a=square(Math.sin(lat_dif/2))+Math.cos(lat1)*Math.cos(lat2)*square(Math.sin(lng_dif/2));
        const d=2*r*Math.asin(Math.sqrt(a));
        if (miles){return d * 0.621371;} //return miles
        else{return `${d.toFixed(1)} Km`;} //return km
    }

  return (
    <div>
        {loading ?  (
            <div style={{height: 120, margin: 20, padding: 10, textAlign: 'center', marginTop: '60%'}}>
                <CircularProgress color="secondary" size={50}/>
                <span style={{display: 'grid', marginTop: 20}}>Ciee udah laper ya?...</span>
            </div>
        ) : (
            <>
                <Link to='/' className="back-button">
                    <ArrowBackIosIcon style={{color: 'red'}}/>
                </Link>
                {/*<div>*/}
                {/*    <MapWithAMarker*/}
                {/*        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC5vsZ5_i3euLtKBmrPTcDM7ztQeAFa8HY&v=3.exp&libraries=geometry,drawing,places"*/}
                {/*        loadingElement={<div style={{ height: `100%` }} />}*/}
                {/*        containerElement={<div style={{ height: map.height - 200 }} />}*/}
                {/*        mapElement={<div style={{ height: `100%` }} />}*/}
                {/*    />*/}
                {/*</div>*/}
                <div style={{marginTop: 80}}>
                    {resto.length > 0 ? resto.map((val, key) => {
                        console.log(key, rand, 'helo val');

                        if(rand === key ) {
                            return(
                                <div className="box-container"
                                     key={key}>
                                    <img
                                        src={val.restaurant.thumb || 'https://gdpr.be/wp-content/themes/cranium-new/images/default-thumb.png'}
                                        alt="helo"
                                        style={{
                                            height: 300,
                                            width: 'auto',
                                            display: 'block',
                                            borderRadius: 20,
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            objectFit: 'contain',
                                        }}
                                    />
                                    <div style={{
                                        height: 50,
                                        display: 'inline-block',
                                        verticalAlign: 'top',
                                        marginLeft: 10,
                                        marginRight: 10,
                                        marginTop: 20,
                                    }}>
                                        <span className="restaurant-details">
                                            {val.restaurant.name}
                                        </span>
                                        <span className="restaurant-details price">
                                            {currencyFormat(val.restaurant.currency, val.restaurant.average_cost_for_two)}
                                        </span>
                                        <span className="restaurant-details distance">
                                            {getDistanceFromLatLng(map.markerPosition.lat,map.markerPosition.lng, val.restaurant.location.latitude, val.restaurant.location.longitude, undefined)} {` away`}
                                        </span>
                                        <Rating name="half-rating-read" defaultValue={val.restaurant.user_rating.aggregate_rating} precision={0.5} readOnly />
                                        <span className="rating-status">{val.restaurant.user_rating.rating_text}</span>
                                    </div>
                                    <div className="eat-now">
                                        <Button variant="contained" color="secondary" style={{borderRadius: 40, width: '100%', height: 70}} onClick={() => myNavFunc(val.restaurant.location.latitude, val.restaurant.location.longitude)}> Eat Now </Button>
                                    </div>
                                    <div className="spin-again">
                                        <Button variant="outlined" color="secondary" style={{borderRadius: 40, width: '100%', height: 70, borderWidth: 'medium'}} onClick={() => fetchResto()}> Cari Lagi </Button>
                                    </div>
                                </div>
                            )
                        } else {
                            return null;
                        }
                    }) : <div style={{height: 120, margin: 20, padding: 10, textAlign: 'center'}}>
                        Gak ada resto yang terdaftar di dekat kamu :(
                    </div>}
                </div>
            </>
        )}
    </div>
  );
}
